// extracted by css-extract-rspack-plugin
export default {"appointmentsWidget":"appointmentsWidget-fTwBbO"};